import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  TabsContainer,
  TabsHeader,
  Tab,
  TabContent,
} from "./PlaygroundTabs.styled";
import { observer } from "mobx-react";
import { useStore } from "../../../hooks";

const Tabs2 = observer(
  ({
    tabs,
    onToggleTab,
    showBorder,
    width,
    blockToggle = false,
    onToggleBlocked,
    defaultTab,
  }) => {
    const { authStore } = useStore();
    const [activeTab, setActiveTab] = useState(defaultTab || 0);

    const hasPermission = useCallback(
      (tab) => {
        if (!tab.permission) return true;
        return authStore.hasPermission(
          tab.permission.code,
          tab.permission.level
        );
      },
      [authStore]
    );
    
    useEffect(() => {
      // Only update activeTab if the new defaultTab corresponds to an enabled tab
      if (defaultTab !== undefined && !tabs[defaultTab]?.disabled) {
        setActiveTab(defaultTab);
      } else {
        // Find the first non-disabled tab
        const firstEnabledTab = tabs.findIndex(tab => !tab.disabled);
        if (firstEnabledTab !== -1) {
          setActiveTab(firstEnabledTab);
        }
      }
    }, [defaultTab, tabs]);

    const renderTabs = (tabs) => {
      return tabs.map(
        (tab, index) => {
          const tabClick = () => {
            if (tab.disabled) {
              tab?.onDisabled?.();
              return;
            }
            handleTabClick(index);
          };

          return hasPermission(tab) && (
            <Tab
              key={index}
              isActive={activeTab === index}
              onClick={tabClick}
              disabled={tab.disabled}
            >
              {tab.label}
            </Tab>
          )
        }
      );
    };

    const handleTabClick = (index) => {
      if (blockToggle) return onToggleBlocked?.();
      setActiveTab(index);
      onToggleTab && onToggleTab(index);
    };

    return (
      <TabsContainer>
        <TabsHeader showBorder={showBorder} width={width}>
          {renderTabs(tabs)}
        </TabsHeader>
      </TabsContainer>
    );
  }
);

Tabs2.Outlet = ({ show, children, disabled }) => {
  return show && !disabled ? <TabContent isShow={show}>{children}</TabContent> : null;
};

export default Tabs2;
